import { injectable, inject } from 'inversify';
import type { IAdicionalRepository } from '@/domain/repositories/IAdicionalRepository';
import { Adicional } from '@/domain/entities/Adicional';
import { TYPES } from '@/di/tokens';

@injectable()
export class ListAdicionalesAction {
  constructor(
    @inject(TYPES.IAdicionalRepository)
    private adicionalRepository: IAdicionalRepository
  ) {}

  async execute(search?: string, activo?: boolean): Promise<Adicional[]> {
    return await this.adicionalRepository.getAll(search, activo);
  }
}
